document.addEventListener("DOMContentLoaded", () => {
  const DURATION = 900;   // 15:00 - initial reservation window
  const FALLBACK = 300;   // 5:00  - restart duration after expiry

  let timerInterval = null;
  let cartHasLimited = false;

  // --- Helpers -----------------------------------------------------------
  // The drawer owns #cart-timer / .cart-timer__wrapper; the cart page adds
  // [data-cart-timer] / [data-cart-timer-wrapper]. Every match is kept in sync.

  function getTimerEls() {
    return document.querySelectorAll("#cart-timer, [data-cart-timer]");
  }

  function getWrapperEls() {
    return document.querySelectorAll(".cart-timer__wrapper, [data-cart-timer-wrapper]");
  }

  function formatTime(totalSeconds) {
    const m = String(Math.floor(totalSeconds / 60)).padStart(2, "0");
    const s = String(totalSeconds % 60).padStart(2, "0");
    return `${m}:${s}`;
  }

  // --- Timer core --------------------------------------------------------

  function startTimer(duration) {
    if (!getTimerEls().length) return;

    clearInterval(timerInterval);

    // Restore from session, or start fresh with the given duration
    let remaining = parseInt(sessionStorage.getItem("cartTimer"), 10);
    if (isNaN(remaining) || remaining <= 0) {
      remaining = duration;
    }

    const tick = () => {
      const text = formatTime(remaining);
      getTimerEls().forEach((el) => { el.textContent = text; });
      sessionStorage.setItem("cartTimer", remaining);

      if (remaining <= 0) {
        clearInterval(timerInterval);
        sessionStorage.removeItem("cartTimer");
        // Restart at fallback duration
        startTimer(FALLBACK);
        return;
      }

      remaining--;
    };

    tick(); // render immediately, then every second
    timerInterval = setInterval(tick, 1000);
  }

  function stopTimer() {
    clearInterval(timerInterval);
    timerInterval = null;
    sessionStorage.removeItem("cartTimer");
  }

  // --- Show / hide -------------------------------------------------------

  function showTimer() {
    const wrappers = getWrapperEls();
    if (!wrappers.length) return;
    wrappers.forEach((w) => w.classList.remove("hidden"));
    startTimer(DURATION);
  }

  function hideTimer() {
    getWrapperEls().forEach((w) => w.classList.add("hidden"));
    stopTimer();
  }

  // --- Cart check --------------------------------------------------------

  let checkDebounce = null;

  async function checkCartAndToggleTimer() {
    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();

      cartHasLimited = cart.items.some(item =>
        item.product_title?.includes("Limited")
      );

      cartHasLimited ? showTimer() : hideTimer();
    } catch (err) {
      console.error("[cart-timer] Cart check failed:", err);
    }
  }

  function debouncedCheck(ms = 500) {
    clearTimeout(checkDebounce);
    checkDebounce = setTimeout(checkCartAndToggleTimer, ms);
  }

  // --- Fetch interceptor -------------------------------------------------

  const CART_MUTATING = [
    "/cart/add",
    "/cart/change",
    "/cart/update",
    "/cart/clear",
  ];

  const _fetch = window.fetch;
  window.fetch = async (...args) => {
    const response = await _fetch(...args);

    const url = typeof args[0] === "string" ? args[0] : args[0]?.url ?? "";
    if (CART_MUTATING.some(path => url.includes(path))) {
      debouncedCheck();
    }

    return response;
  };

  // --- Cart drawer open --------------------------------------------------

  document.addEventListener("theme:cart:open", () => {
    if (!cartHasLimited) return;

    const wrappers = getWrapperEls();
    if (!wrappers.length) return;

    wrappers.forEach((w) => w.classList.remove("hidden"));

    // Only restart the timer if it's not already running
    if (!timerInterval) {
      startTimer(DURATION);
    }
  });

  // --- Init --------------------------------------------------------------

  checkCartAndToggleTimer();
});
